'use strict';

angular.module('licensure.helpers')
    .factory('Authentication', ['$injector', '$q', 'localStorageService', '$rootScope', function ($injector, $q, localStorageService, $rootScope) {
        var authenticationData = null;
        var gettingAuthentication = false;

        var authenticate = function (isPortal) {
            var d = $q.defer();
            var $http = $injector.get('$http');

            $http.post(apiLocation + '/token', "grant_type=environment&isPortal=" + isPortal, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).
            then(function (response) {
                // set when the token expires
                //var t = new Date();
                //t.setSeconds(t.getSeconds() + data.expires_in);
                //data.expires = t;

                if (isPortal) {
                    localStorageService.set('portalAuthorizationData', response.data);
                }
                else {
                    localStorageService.set('internalAuthorizationData', response.data);
                }
                d.resolve(response.data);
            })
                .catch(function (response) {
                    d.reject(response.data);
                });

            return d.promise;
        }

        var login = function (args) {
            var d = $q.defer();
            var $http = $injector.get('$http');

            args.grant_type = "password";
            args.enterpriseID = $rootScope.enterpriseID;
            args.password = args.pass;

            $http.post(apiLocation + '/api/Core/Auth/Login', args).
                then(function (response) {
                    // set when the token expires
                    //var t = new Date();
                    //t.setSeconds(t.getSeconds() + data.expires_in);
                    //data.expires = t;

                    if (args.isPortal) {
                        localStorageService.set('portalAuthorizationData', response.data);
                    }
                    else {
                        localStorageService.set('internalAuthorizationData', response.data);
                    }
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    d.reject(response.data);
                });

            return d.promise;
        }

        var setRootScope = function (authData) {
            $rootScope.userID = authData.user_id;
            $rootScope.enterpriseID = authData.enterprise_id;
            $rootScope.internalURL = authData.internalURL;
            $rootScope.portalURL = authData.portalURL;
            $rootScope.portalCSS = authData.portalCSS;
            $rootScope.portalTopMenu = authData.portalTopMenu;
            $rootScope.isPortal = authData.is_portal;
            authenticationData = authData;
        }

        return {
            get: function (isPortal) {
                var d = $q.defer();
                var authData;

                if (isPortal) {
                    authData = localStorageService.get('portalAuthorizationData');
                    if (!authData && $rootScope.$state.current.params && $rootScope.$state.current.params.loginRequired) {
                        //Try to get authentication (but only for tabs where login is required)
                        if (!gettingAuthentication) {
                            gettingAuthentication = true;
                            authenticate(isPortal).then(function (data) {
                                setRootScope(data);
                                gettingAuthentication = false;
                                $rootScope.$broadcast('Authentication:finish');
                                d.resolve(data);
                            }).catch(function (error) {
                                // handle the error  
                            });
                        }
                        else {
                            $rootScope.$on('Authentication:finish', function () {
                                d.resolve(authenticationData);
                            });
                        }
                    }
                    else if (!authData) {
                        d.resolve(null);
                    }
                    else {
                        setRootScope(authData);
                        d.resolve(authData);
                    }
                }
                else {
                    authData = localStorageService.get('internalAuthorizationData');

                    if (!authData && $rootScope.$state.current.params && $rootScope.$state.current.params.allowAnonymous) {
                        d.resolve(null);
                    }
                    else if (!authData) {
                        if (!gettingAuthentication) {
                            gettingAuthentication = true;
                            authenticate(isPortal).then(function (data) {
                                setRootScope(data);
                                gettingAuthentication = false;
                                $rootScope.$broadcast('Authentication:finish');
                                d.resolve(data);
                            }).catch(function (error) {
                                // handle the error  
                            });
                        }
                        else {
                            $rootScope.$on('Authentication:finish', function () {
                                d.resolve(authenticationData);
                            });
                        }
                    }
                    else {
                        setRootScope(authData);
                        d.resolve(authData);
                    }
                }

                return d.promise;
            },

            login: login,

            authenticate: authenticate
        }
    }])
;